import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-6 max-w-2xl mx-auto bg-navy-800/50 rounded-2xl my-12" data-id="element-183">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-184">
        <h2 className="font-serif text-3xl md:text-4xl text-gold-400 mb-10" data-id="element-185">
          Why "we'll take turns" doesn't work
        </h2>

        <div className="space-y-8 text-lg md:text-xl leading-loose-p text-cream-50" data-id="element-186">
          <p data-id="element-187">Most couples have tried some version of shifts.</p>
          <p data-id="element-188">And it still collapses because:</p>

          <ul className="space-y-6 my-8" data-id="element-189">
            {["The blocks aren't fixed, so every wake-up becomes a vote.", "The handoff isn't scripted, so it becomes a debate.", 'The OFF parent is never really OFF, so nobody truly recovers.', 'Resentment leaks into logistics and poisons the next night.'].map((item, i) => <li key={i} className="flex items-start gap-4 p-4 bg-navy-900/50 rounded-lg border border-white/5" data-id="element-190">
                <span className="text-red-400/80 font-serif text-xl" data-id="element-191">✕</span>
                <span data-id="element-192">{item}</span>
              </li>)}
          </ul>

          <p data-id="element-193">At night, you're not negotiating with your partner.</p>
          <p data-id="element-194">You're negotiating with two exhausted nervous systems.</p>
          <p className="font-serif text-2xl text-gold-400 italic text-center py-6" data-id="element-195">
            So you need something that can run on autopilot.
          </p>
        </div>
      </motion.div>
    </section>;
}